import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import PropTypes from 'prop-types';
import styles from './Input.module.css';

const cx = classNames.bind(styles)

const InputTextBox = ({ title, onChange, value, placeholder, type, style, className, error, titleError, disabled, size = "normal", submit }) => {
  const [isChange, setIsChange] = useState(false)
  const onChanges = (e) => {
    onChange(e.target.value)
    setIsChange(true)
  }

  useEffect(() => {
    if(submit) {
      setIsChange(true)
    }
  }, [submit])
  return (

    <div style={{ ...style, color: error && isChange ? "#F25B60" : "rgba(0, 0, 0, 0.7)" }} className={cx("form-group")}>
      <label className={cx("title")}>{title}</label>
      <input
        value={value ? value : ""}
        className={cx("input-textbox", className, error && isChange ? "input-error" : "", size)}
        onChange={onChanges}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={155}
      />
      {isChange && error && <span className={cx("span-error")} style={{ position: "absolute" }}>{titleError}</span>}

    </div>
  );
};
InputTextBox.propTypes = {

  title: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.any,
  className: PropTypes.any,
  error: PropTypes.bool,
  titleError: PropTypes.string,
  disabled: PropTypes.bool
};
export default InputTextBox;
